import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronFillDown = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.691 10.659H33.31c2.393 0 3.59 2.896 1.9 4.585L21.902 28.553a2.673 2.673 0 0 1-3.791 0L4.79 15.244c-1.689-1.689-.492-4.585 1.901-4.585Z" })
});
export default SvgChevronFillDown;
